const Auth = () => import('@/views/Auth');
const Geolocation = () => import('@/views/Geolocation');
const Sms = () => import('@/views/Sms');
const ContactUs = () => import('@/views/ContactUs');
const ClientConfirmation = () => import('@/views/ClientConfirmation');
const PasswordReset = () => import('@/views/PasswordReset');
const Assistance = () => import('@/views/Assistance');
const ListCicloUrbano = () => import('@/components/lodgings/ListCicloUrbano');
const ListAgroServices = () => import('@/components/lodgings/ListAgroServices');
const ListUrbanPlagas = () => import('@/components/lodgings/ListUrbanPlagas');
const ListBiotecPlagas = () => import('@/components/lodgings/ListBiotecPlagas');
const ListCicloUrbanoPiscinas = () => import('@/components/lodgings/ListCicloUrbanoPiscinas');
const ListRRPlagas = () => import('@/components/lodgings/ListRRPlagas');
const FormMobileRRPlagas = () => import('@/components/lodgings/FormMobileRRPlagas');

export default [
	{
		path: '/passwordReset',
		name: 'passwordReset',
		component: PasswordReset,
		meta: { title: 'Recuperar contraseña', layout: 'simple' },
	},
	{
		path: '/contact-us',
		name: 'contact',
		component: ContactUs,
		meta: { title: 'Contacto', layout: 'simple' },
	},
	{
		path:
			'/geolocation/person/:id/token/:token/lodging/:lodging/notification/:idNotification/handler/:handler',
		name: 'geolocation',
		component: Geolocation,
		meta: { title: 'Confirmar geolocalización', layout: 'simple' },
	},
	{
		path: '/sms/person/:id/token/:token/lodging/:lodging/notification/:idNotification',
		name: 'confirm-sms',
		component: Sms,
		meta: { title: 'Confirmar Actividad', layout: 'simple' },
	},
	{
		path: '/client-confirmation/:idLodging',
		name: 'client-confirmation',
		component: ClientConfirmation,
		meta: { title: 'Confirmar Actividad', layout: 'simple' },
	},
	{
		path: '/assistance',
		name: 'assistance',
		component: Assistance,
		meta: { title: 'Asistencia', layout: 'simple' },
	},
	{
		path: '/auth',
		name: 'auth',
		component: Auth,
		meta: { title: 'Autenticación', layout: 'simple' },
	},
	{
		path: '/ciclo-urbano/:idLodging/work-order/:index/',
		name: 'list-ciclo-urbano',
		component: ListCicloUrbano,
		meta: { title: 'Ciclo urbano', layout: 'simple' },
	},
	{
		path: '/agro-services/:idLodging/work-order/:index/',
		name: 'list-agro-service',
		component: ListAgroServices,
		meta: { title: 'Agroservices', layout: 'simple' },
	},
	{
		path: '/urban-plagas/:idLodging/work-order/:index/',
		name: 'list-urban-plagas',
		component: ListUrbanPlagas,
		meta: { title: 'Urban Plagas', layout: 'simple' },
	},
	{
		path: '/ciclo-urbano-piscinas/:idLodging/work-order/:index/',
		name: 'list-ciclo-urbano-piscinas',
		component: ListCicloUrbanoPiscinas,
		meta: { title: 'Ciclo urbano piscinas', layout: 'simple' },
	},
	{
		path: '/biotec-plagas/:idLodging/work-order/:index/',
		name: 'list-biotec-plagas',
		component: ListBiotecPlagas,
		meta: { title: 'Biotec plagas', layout: 'simple' },
	},
	{
		path: '/rrplagas/:idLodging/work-order/:index/',
		name: 'list-rrplagas',
		component: ListRRPlagas,
		meta: { title: 'RR Plagas', layout: 'simple' },
	},
	{
		path: '/rrplagas-certificate/:idLodging/work-order/:index/',
		name: 'list-certificate-rrplagas',
		component: ListRRPlagas,
		meta: { title: 'RR Plagas', layout: 'simple' },
	},
	{
		path: '/nueva-orden-de-trabajo-mobile/rrplagas/',
		name: 'form-rrplagas-mobile',
		component: FormMobileRRPlagas,
		meta: { title: 'Nueva orden de trabajo', layout: 'simple' },
	},
];
